import React, { Component } from 'react';

import Button from '../../artzu-ui/src/Button';
import Divider from '../../artzu-ui/src/Divider';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { active, onNextClick, onBackClick, children, label, next = true, back } = this.props;

    return (
      <div className={`apply__footer ${children ? 'apply__footer--tall' : ''} update-password__footer`}>
        <div className="apply__footer--container container">
          <Divider />
          <div className={`apply__footer--button-container ${children ? 'apply__footer--button--tall' : ''}`}>
            {back ? (
              <div className="apply__footer--button-back apply__desktop">
                <Button
                  className="apply__footer--button"
                  size="xl"
                  fullWidth
                  label="Previous"
                  onClick={() => onBackClick()}
                />{' '}
              </div>
            ) : null}
            <div className="apply__footer--button-child">{children}</div>
            {next ? (
              <div className="apply__footer--button-next">
                <Button
                  className="apply__footer--button"
                  size="xl"
                  disabled={!active}
                  primary={true}
                  fullWidth
                  color={'#128DFF'}
                  label={label || 'Next'}
                  onClick={() => onNextClick()}
                />{' '}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/UpdatePassword/UpdatePasswordFooter.js